import Vue from 'vue';
import Vuex from 'vuex';
import LRSettingsState from './modules/liverate-settings';
import UsersState from './modules/users';
import http from '@/js/http';

Vue.use(Vuex);

// MENU FOR INDEX
const MENUS = {
    Dashboards: 0,
    Users: 1,
    Accounts: 2,
    Integrations: 3,
    Logs: 4,
    LiveRatesLogs: 5,
    WebHooks: 6,
    Queue: 7,
    BulkItems: 8,
    BulkPickslip: 9,
    Platforms: 10,
    DocsPlatform: 11,
    DocsIntegrations: 12,
};

Object.freeze(MENUS);

// MENU BY KEY
const MENU_ITEM = {
    bulk_items: MENUS.BulkItems,
    bulk_pickslips: MENUS.BulkPickslip,
};

Object.freeze(MENU_ITEM);


const store = new Vuex.Store({

    modules: {
        LRSettingsState,
        UsersState
    },

    state: {
        user: {
            id: null,
            name: null,
            roles: null,
            email: null,
            token: null
        },

        menus: null,
        allmenus: [
            // IMPORTANT NOTE! DONT REMOVE ANY OF THE ORDER BELOW IT WILL MESSED UP UI. @TODO WILL IMPROVE THIS
            { title: 'Dashboard',       link: '/',                  icon: '',  group: 'syncs' },             // 0
            { title: 'Users',           link: '/users',             icon: '',  group: 'admin' },             // 1
            { title: 'Accounts',        link: '/accounts',          icon: '',  group: 'admin' },             // 2
            { title: 'Integrations',    link: '/integrations',      icon: '',  group: 'syncs' },             // 3
            { title: 'Sync Logs',       link: '/logs',              icon: '',  group: 'syncs' },             // 4
            { title: 'Live Rate Logs',  link: '/live-rates/logs',   icon: '',  group: 'syncs' },             // 5
            { title: 'Web Hooks',       link: '/webhooks/logs',     icon: '',  group: 'syncs' },             // 6

            { title: 'Queue',           href: '/horizon/dashboard', icon: '',  group: 'admin' },             // 7

            { title: 'Bulk Items',      link: '/bulk-items',        icon: '',  group: 'syncs' },             // 8
            { title: 'Bulk Pickslip',   link: '/bulk-pickslips',    icon: '',  group: 'syncs' },             // 9

            { title: 'Platforms',       link: '/platforms',         icon: '',  group: 'syncs' },             // 10

            { title: 'Platform Docs',   href: '/docs/platforms',    icon: '',  group: 'syncs' },             // 11
            { title: 'Integration Docs',href: '/docs/integrations', icon: '',  group: 'syncs' },             // 12
        ],


        // here we decide which menu will be display for each roles
        userRoles: {
            'Super Admin': -1, // all menu access
            'Admin': [
                MENUS.Dashboards,
                MENUS.Users,
                MENUS.Accounts,
                MENUS.Integrations,
                MENUS.Logs,
                MENUS.CarrierService,
                MENUS.WebHooks,
                MENUS.Queue,
                MENUS.BulkItems,
                MENUS.BulkPickslip,
                MENUS.Platforms,
                MENUS.DocsIntegrations,
                MENUS.DocsPlatform
            ],
            'User': [
                MENUS.Integrations,
                MENUS.Logs,
            ],
        },

        integrations: [],
        isTestIntegration: false,
        activeIntegration: null
    },
    mutations: {
        FETCH_USER(state, user) {
            state.user = user
        },
        FETCH_INTEGRATIONS(state, integrations) {
            state.integrations = integrations
        },

        SET_ACTIVE_INTEGRATION(state, integration) {
            state.activeIntegration = integration
            localStorage.setItem('active_integration', integration)
        },

        SET_IS_TEST_INTEGRATION(state, isTest) {
            state.isTestIntegration = isTest
            localStorage.setItem('is_test_integration', isTest)
        },
        UPDATE_TOKEN(state, newToken) {
            state.user.token = newToken;
        },
    },

    actions: {
        setUser({ commit, state }, data) {
            // state.user = data
            commit("FETCH_USER", data);
        },
        setIntegrations({ commit, state }, data) {
            commit("FETCH_INTEGRATIONS", data)
        },

        setActiveIntegration({ commit, state }, data) {
            commit("SET_ACTIVE_INTEGRATION", data)
        },

        setIsTestIntegration({ commit, state }, data) {
            commit("SET_IS_TEST_INTEGRATION", data)
        },

        updateToken({ commit, state }, data) {
            commit("UPDATE_TOKEN", data);
        }
    },

    getters: {
        getActiveIntegration(state) {
            return state.activeIntegration
        },
        isTestIntegration(state) {
            return state.isTestIntegration
        },
        getIntegrations(state) {
            return state.integrations
        },
        getUser(state) {
            return state.user
        },
        getMenus(state) {

            // getting all integrations will be required for getting menus
            if (!state.integrations) {
                return
            }

            let menus = []
            let userMenus = []
            let roles = state.user.roles
            let allmenus = state.allmenus
            let userRoles = state.userRoles
            let isUser = roles ? roles[0] === 'User' : false

            if (roles) {
                // now we need to determine which menu index does this user will have
                roles.forEach(role => {
                    if (userRoles[role]) {
                        if (Array.isArray(userRoles[role])) {
                            userMenus = userMenus.concat(userRoles[role]);
                        } else {
                            userMenus.push(state.userRoles[role])
                        }
                    }
                })
            }

            // next we need to apply the new feature of other optional menus
            if (isUser) {
                let ids = state.user.integration_ids
                ids.forEach(id => {
                    let integration = state.integrations.find(integ => integ.id == id)

                    if (!integration) {
                        return;
                    }

                    // check if we have other menus for this integration
                    let othermenu = integration.attributes.other_menu
                    if (othermenu && othermenu.length > 0) {
                        othermenu.forEach(index => {
                            if (MENU_ITEM[index]) {
                                userMenus.push(MENU_ITEM[index])
                            }
                        })
                    }

                    // check if there are liverates
                    let liverates = integration.attributes.live_rate
                    if (liverates && liverates == 'TRUE') {
                        allmenus.forEach((menu, index) => {
                            if (menu.group == 'liverates') {
                                userMenus.push(index)
                            }
                        });
                    }
                })
            }

            // prepare the menus once user menu has an item
            if (userMenus.length > 0) {
                allmenus.forEach((menu, index) => {
                    if (userMenus.indexOf(-1) >= 0 || userMenus.indexOf(index) >= 0) {
                        menus.push(menu)
                    }
                })
            }

            return menus
        },
        getActiveIntegrationMeta(state) {
            if (state.user.roles[0] === 'User') {
                let id = state.user.integration_ids[0]
                let integration = state.integrations.find(integ => integ.id == id)
                return integration
            } else {
                return state.integrations[state.activeIntegration]
            }
        },
        // check whether this is an admin or not
        isAdmin(state) {
            return state.user.roles[0] === 'User' ? false : true
        },

        isSuperAdmin(state) {
            return state.user.roles[0] === 'Super Admin'
        }
    }
})

export default store;